import { usergetRoleByUser } from '@/api/configApi'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token:getToken(),
    roles: [],
    userInfo:'',
  },

  mutations: {
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
  },
  actions: {
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        usergetRoleByUser().then(response => {
          const data = response.data
         console.log(data)
          commit('SET_ROLES', data.role)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js